import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { createContactPersonAsync, deleteContactPersonByIdAsync, getContactPersonsByCreditorIdAsync, updateContactPersonAsync } from '@application/features/creditures/creditureThunk';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import VnValidation from '@ui/components/VnValidation';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import { handleRolePermission } from '@infrastructure/helpers';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
const ContactPersonForm = ({ onClose, isContactPersonTabBold }) => {
    const dispatch = useAppDispatch();
    const { contactPersoon } = useAppSelector((state) => state.crediture);
    const { id } = useParams();
    const [isCrediureDeletePopup, setisCreditureDeletePopup] = useState(false);
    const { setValue, handleSubmit, register, formState: { errors } } = useForm({
        defaultValues: {}
    });
    const onCreateSubmit = (data) => {
        data.creditorId = parseInt(id);
        dispatch(createContactPersonAsync(data))
            .unwrap()
            .then((res) => {
            if (id) {
                dispatch(getContactPersonsByCreditorIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    if (isContactPersonTabBold && res.length > 0) {
                        isContactPersonTabBold(true);
                    }
                    else {
                        isContactPersonTabBold && isContactPersonTabBold(false);
                    }
                });
            }
            onClose();
        });
    };
    const onUpdateSubmit = (data) => {
        dispatch(updateContactPersonAsync(data))
            .unwrap()
            .then((res) => {
            if (id) {
                dispatch(getContactPersonsByCreditorIdAsync(parseInt(id)));
            }
            onClose();
        });
    };
    function openDeleteConformationPopup() {
        setisCreditureDeletePopup(true);
    }
    const onCancelDeleteClicked = () => {
        setisCreditureDeletePopup(false);
    };
    const onDeleteClicked = (contactPersonId) => {
        dispatch(deleteContactPersonByIdAsync(contactPersonId))
            .unwrap()
            .then((res) => {
            setisCreditureDeletePopup(false);
            if (id) {
                dispatch(getContactPersonsByCreditorIdAsync(parseInt(id)))
                    .unwrap()
                    .then((res) => {
                    if (isContactPersonTabBold && res.length > 0) {
                        isContactPersonTabBold(true);
                    }
                    else {
                        isContactPersonTabBold && isContactPersonTabBold(false);
                    }
                });
            }
            onClose();
        });
    };
    useEffect(() => {
        setValue('creditorId', contactPersoon?.creditorId);
        setValue('debtorId', contactPersoon?.debtorId);
        setValue('firstName', contactPersoon?.firstName);
        setValue('lastName', contactPersoon?.lastName);
        setValue('note', contactPersoon?.note);
        setValue('position', contactPersoon?.position);
        setValue('phoneNumber', contactPersoon?.phoneNumber);
        setValue('id', contactPersoon?.id);
        setValue('email', contactPersoon?.email);
    }, [contactPersoon]);
    return (_jsxs(_Fragment, { children: [_jsxs("form", { onSubmit: contactPersoon ? handleSubmit(onUpdateSubmit) : handleSubmit(onCreateSubmit), children: [_jsxs("div", { className: 'mt-3', children: [_jsxs("div", { className: 'row mt-3', children: [_jsxs("div", { className: 'col', children: [_jsx("label", { children: "Voornaam*" }), _jsx("input", { type: 'text', className: 'form-control vn-Input mt-2', placeholder: 'Voer voornaam in', ...register('firstName', {
                                                    required: 'Dit veld is verplicht'
                                                }) }), _jsx(VnValidation, { fieldError: errors.firstName })] }), _jsxs("div", { className: 'col', children: [_jsx("label", { children: "Achternaam" }), _jsx("input", { type: 'text', className: 'form-control vn-Input mt-2', placeholder: 'Voer achternaam in', ...register('lastName') })] })] }), _jsxs("div", { className: 'row mt-3', children: [_jsxs("div", { className: 'col', children: [_jsx("label", { children: "Functie" }), _jsx("input", { type: 'text', className: 'form-control vn-Input mt-2', placeholder: 'Voer functie in', ...register('position') })] }), _jsx("div", { className: 'col' })] }), _jsxs("div", { className: 'row mt-3', children: [_jsxs("div", { className: 'col', children: [_jsx("label", { children: "Telefoonnummer" }), _jsx("input", { type: 'text', className: 'form-control vn-Input mt-2', placeholder: 'Voer telefoonnummer in', ...register('phoneNumber'), onInput: (e) => {
                                                    e.currentTarget.value = e.currentTarget.value.replace(/[^\d+\s()-]/g, '');
                                                } })] }), _jsxs("div", { className: 'col', children: [_jsx("label", { children: "Mail adres" }), _jsx("input", { type: 'text', className: 'form-control vn-Input mt-2', placeholder: 'Voer email in', ...register('email', {
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                        message: 'Ongeldig e-mailadres'
                                                    }
                                                }) }), _jsx(VnValidation, { fieldError: errors.email })] })] }), _jsx("div", { className: 'row mt-3', children: _jsxs("div", { className: 'col-sm-12', children: [_jsx("label", { className: 'form-label vn-text-label', children: "Opmerkingen" }), _jsx("textarea", { className: 'vn-Input', rows: 8, placeholder: 'Voer opmerkingen in', ...register('note') })] }) })] }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', type: 'button', onClick: onClose, children: "Annuleren" }), contactPersoon ? (_jsxs(_Fragment, { children: [_jsx(VnButton, { style: { marginLeft: '8px' }, customClassName: 'vn-popup-delete-button', mode: 'danger', type: 'button', onClick: () => openDeleteConformationPopup(), isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Delete), children: "Verwijderen" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Update), children: "Opslaan" })] })) : (_jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'submit', isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Create), children: "Opslaan" }))] }) })] }), _jsx(VnConfirmationModel, { title: 'Wilt u dit record verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(contactPersoon?.id), onOpen: isCrediureDeletePopup })] }));
};
export default ContactPersonForm;
